import React, { type FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { type Theme, Tooltip } from '@mui/material'
import { StyledLabel } from '../meter-configuration/MeterConfiguration.style'
import { useTranslation } from 'react-i18next'

const useLabelsFieldStyles = makeStyles()((theme: Theme) => {
  return {
    root: {
      display: 'flex',
      listStyle: 'none',
      margin: 0,
      padding: '0',
      minWidth: '200px',
      minHeight: '30px'
    },
    chip: {
      margin: theme.spacing(0.5)
    }
  }
})

interface MetersTableLabelsFieldProps {
  meterLabels: string[]
  onLabelExpandClick: () => void
  labelVisibility?: React.CSSProperties
}

export const MetersTableLabelsField: FC<MetersTableLabelsFieldProps> = (props) => {
  const { meterLabels, onLabelExpandClick, labelVisibility } = props
  const { classes } = useLabelsFieldStyles()
  const { t } = useTranslation()

  const toolTipTitle = t('labels.showAllLabels') ?? ''

  if (meterLabels.length === 0) {
    return (<div className={classes.root} style={labelVisibility}/>)
  }

  return (
        <div className={classes.root} style={labelVisibility}>
            {meterLabels.slice(0, 2).map((label, index) => {
              return (
                    <li key={index}>
                        <StyledLabel label={label} className={classes.chip}/>
                    </li>
              )
            })}
            {meterLabels.length > 2
              ? (
                    <Tooltip arrow title={toolTipTitle}>
                        <StyledLabel label={`+${meterLabels.length - 2}`} style={{ backgroundColor: '#a7a7a7' }}
                                     onClick={() => {
                                       onLabelExpandClick()
                                     }}/>
                    </Tooltip>
                )
              : undefined}
        </div>
  )
}
